module.exports = __webpack_public_path__ + "img/sun-7522095_1280_thumb.cff62b14.jpg";